/** The customer Statement of Account: labels, tones and the query string. */
import type { ChipTone } from '../components/ui';

export type StatementStatus = 'PAID' | 'PARTIALLY_PAID' | 'UNPAID' | 'OVERDUE';
export type StatementFilter = 'ALL' | 'PAID' | 'PENDING';

export const STATEMENT_LABELS: Record<StatementStatus, string> = {
  PAID: 'Paid',
  PARTIALLY_PAID: 'Partially paid',
  UNPAID: 'Unpaid',
  OVERDUE: 'Overdue',
};

export const STATEMENT_TONES: Record<StatementStatus, ChipTone> = {
  PAID: 'ok',
  PARTIALLY_PAID: 'warning',
  UNPAID: 'info',
  OVERDUE: 'critical',
};

export const FILTER_LABELS: Record<StatementFilter, string> = {
  ALL: 'All',
  PAID: 'Paid',
  PENDING: 'Pending',
};

export interface StatementFilters {
  from: string;
  to: string;
  status: StatementFilter;
}

/** Only what is set goes on the URL: "all time" and "All" are the defaults. */
export function statementQuery(filters: StatementFilters): string {
  const params = new URLSearchParams();
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.status !== 'ALL') params.set('status', filters.status);
  return params.toString();
}

/** A from date after the to date would return nothing; say so instead. */
export function rangeError(filters: Pick<StatementFilters, 'from' | 'to'>): string | null {
  if (filters.from && filters.to && filters.from > filters.to) {
    return 'The "from" date is after the "to" date.';
  }
  return null;
}

export function parseFilter(value: string | null): StatementFilter {
  return value === 'PAID' || value === 'PENDING' ? value : 'ALL';
}
